import api from '../api'

const baseUrl = '/academy/api/Invitation/CustomerClub'

const skillUpCustomersClub = {
  fetchCustomersClub() {
    return api.get(baseUrl)
  },
  updateCustomerClub(params) {
    return api.post(baseUrl, params)
  },
}

export default skillUpCustomersClub
